<rask-page
    pageTitle="{{title}}"
    [actionShow]="true"
    [actionFn]="skapaAnbudKontrakt"
    actionTitle="{{texts.nyttSkogsvardsuppdrag}}"
    noPadding
    [footerShow]="false"
>
    <ng-container headerContent>
        <rask-sok-skogsvard-fpv-avtal></rask-sok-skogsvard-fpv-avtal>
    </ng-container>
    <rask-anbud-kontrakt-list [isSkogsvardFPV]="true"></rask-anbud-kontrakt-list>
</rask-page>
